import NextLink from 'next/link';
import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import { linkVariants, type LinkStyleProps } from './link-variants';

export type LinkProps = ComponentPropsWithoutRef<typeof NextLink> &
  LinkStyleProps;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { className, variant = 'default', ...props },
  ref,
) {
  return (
    <NextLink
      ref={ref}
      className={linkVariants({ variant, className })}
      {...props}
    />
  );
});
